import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abe7361e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "combined-goods" }
const _hoisted_2 = { class: "combined-goods-title" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"color":"#da3d3d"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "line--3" }
const _hoisted_8 = { style: {"max-width":"300px"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { style: {"cursor":"pointer"} }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"max-width":"300px"} }
const _hoisted_13 = {
  class: "flex-bwn-wrap",
  style: {"width":"100%","padding":"10px 0"}
}

import { t } from '@/plugins/i18n'
import SSearch from './Search.vue'
import { COUNTRY } from '@/global'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import AdtOrder from '@/components/additional/AdtOrder.vue'
import { WarningFilled } from '@element-plus/icons-vue'
import Guide from '@/components/guide/index.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { countryCodeNameMap } from '@/common/const'
import CustomerProductMsku from './components/CustomerProductMsku.vue'
import { ref, onMounted, toRaw, computed, nextTick } from 'vue'
import {
  getCombinationList,
  combinationAddCart,
  combinationFinished,
  additionEdit
} from '@/apis/combined'
import AppLink from '@/components/common/AppLink.vue'
import { setNoEmptyForm, getJapanTime } from '@/util/common'
import { columns, childColumns, tableConfig } from './data'
import { setAdt, montageAddition } from '@/util/calcAdt'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { isMultiStore, useRtfix } from '@/store'
import { getCartAmount } from '@/apis/shopcart'
import { batchQueryCombinationProduct } from '@/apis/order'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import { showCurrentUnit } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const hasKeywordSku = ref(!!route.query.keywordSku)
const searchForm = ref({})
const filterData = computed(() => {
  if (hasKeywordSku.value) {
    return {
      ...setNoEmptyForm(toRaw(searchForm.value)),
      keywordSku: route.query.keywordSku
    }
  }
  return {
    ...setNoEmptyForm(toRaw(searchForm.value))
  }
})

onMounted(() => {
  refreshTable()
})

// 附加项费
const adtList = ref([])
const proxy: any = ref(null)
const adtProductSku = ref()

const handleAdt = (cartAdditionList: any) => {
  adtList.value = cartAdditionList === 1 ? [] : cartAdditionList
  additionEdit({
    combinationProductAdditionList: adtList.value.map((e: any) => ({
      additionConfigId: e.additionConfigId,
      additionId: e.additionId,
      // TODO additionCode
      additionCode: e.additionCode,
      customerIngredientsSku: e.ingredientsSku
    })),
    combinationProductSku: adtProductSku.value
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('附加项修改成功'))
      refreshTable()
    }
  })
}

const productCountyCode = ref()

const openAdtOrder = (row: any) => {
  adtList.value = row.combinationProductAdditionList
  proxy.value = adtList.value
  adtProductSku.value = row.combinationProductSku
  productCountyCode.value = row.goodsCountry
  console.log(row)
}

const pageData = ref({
  page: 1,
  limit: 30
})

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  selectionList.value = val
}

// 加购跳转的购物车
const jumpCountryCode = ref('CN')
const addSingleCart = async (e: any) => {
  jumpCountryCode.value = e.goodsCountry
  e.addLoading = true
  const combinationProductAdts = await batchQueryCombinationProduct({ combinationProductSkus: [e.combinationProductSku], withSubProduct: 1 })
  if (combinationProductAdts.code !== '0') {
    e.addLoading = false
    return
  }
  await addCart([{
    combinationProductItemList: e.combinationProductItemList,
    combinationProductSku: e.combinationProductSku,
    num: 1,
    combinationProductAdt: combinationProductAdts.data[0].combinationProductItems || []
  }])
  e.addLoading = false
}
/** 获取小计 */
const getSubtotal = (value: number) => {
  // 是否小数为大于或等于2
  const isHasTwoDecimals = (value.toString().split('.')[1] || []).length > 2
  if (isHasTwoDecimals) {
    return value.toFixed(2)
  }
  return value
}

const batchAddLoading = ref(false)
const addBatchCart = async () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择商品'))
  batchAddLoading.value = true
  const combinationProductSkus = selectionList.value.map((y: any) => y.combinationProductSku)
  const combinationProductAdts = await batchQueryCombinationProduct({ combinationProductSkus: combinationProductSkus, withSubProduct: 1 })
  if (combinationProductAdts.code !== '0') {
    return
  }
  jumpCountryCode.value = selectionList.value.some((v: { goodsCountry: string }) => v.goodsCountry === COUNTRY.CN) ? COUNTRY.CN : COUNTRY.KR
  await addCart(
    selectionList.value.map((e: any) => ({
      combinationProductItemList: e.combinationProductItemList,
      combinationProductSku: e.combinationProductSku,
      num: 1,
      combinationProductAdt: combinationProductAdts.data.filter((i: any) => i.combinationProductSku === e.combinationProductSku)[0].combinationProductItems || []
    }))
  )
  batchAddLoading.value = false
}
const addCart = async (data: any) => {
  console.log('addCart', data)
  const list: any = []
  await Promise.all(data.map(async (v: any) => {
    const combinationProductAdts = v.combinationProductAdt
    v.combinationProductItemAddCartList = await Promise.all(
      v.combinationProductItemList.map(async (v: any) => {
        const combinationProductAdtItemCache = combinationProductAdts.filter((y: any) => y.shopProductSku === v.shopProductSku)[0]
        // const combinationProductAdtItem = combinationProductAdtItemCache.length ? {
        //   noAdditionalFlag: 0,
        //   combinationProductItemAdditionList: combinationProductAdtItemCache
        // } : null
        const cartAdditionList = await setAdt(v.productCategoryFrontendNdId, 'combinationProductItemAdditionList', 'noAdditionalFlag', combinationProductAdtItemCache?.additionList, combinationProductAdtItemCache?.noAdditionalFlag)

        // const finalAdt = combinationProductAdtItem || cartAdditionList
        return {
          ...cartAdditionList,
          shopProductSku: v.shopProductSku
        }
      })
    )
    list.push({
      combinationProductItemAddCartList: v.combinationProductItemAddCartList,
      combinationProductSku: v.combinationProductSku,
      num: v.num
    })
  }))
  combinationAddCart({
    combinationProductSkuList: list
  }).then((res: any) => {
    if (res.success) {
      showAddCartInfo(list.length)
      refreshTable()
    }
  })
}

const showAddCartInfo = async (len: any) => {
  const amount = await getCartAmount().then((res) => res.data)
  ElMessageBox.confirm(
    `
      <div>${t('X件商品已添加至购物车').replace('X', len)}</div>
      <div>${t('当前购物车共X种商品').replace('X', amount)}</div>
    `,
    t('添加成功'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('去结算'),
      cancelButtonText: t('留在此页'),
      type: 'success'
    }
  ).then(() => {
    router.replace(useRtfix('shopcart', { query: { sc: jumpCountryCode.value } }))
  })
}

const finished = (row: any) => {
  combinationFinished({
    shopProductSkuList: [],
    systemOrderNo: row.systemOrderNo
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('完结成功'))
      refreshTable()
    }
  })
}

const hasWaitCombined = (row: any) => {
  if (
    row.combinationProductItemList &&
    row.combinationProductItemList.length > 0
  ) {
    for (const t of row.combinationProductItemList) {
      return (
        t.remainCombinationProductItemRespList &&
        t.remainCombinationProductItemRespList.length > 0
      )
    }
  } else {
    return false
  }
}

const store = useStore()
const router = useRouter()

const exit = (row: any) => {
  store.commit('goods/CombinedInfo', row)
  router.push(useRtfix('groupProduct'))
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
    if (hasKeywordSku.value) hasKeywordSku.value = false
  })
}
const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = params
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_table_button = _resolveComponent("table-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('组合商品管理')), 1),
    _createVNode(SSearch, {
      form: searchForm.value,
      "onUpdate:form": [
        _cache[1] || (_cache[1] = ($event: any) => ((searchForm).value = $event)),
        search
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(memberEventBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (exit({})))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('创建组合商品')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(memberEventBox, { "listen-variable": batchAddLoading.value }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "warning",
                loading: batchAddLoading.value,
                onClick: addBatchCart
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('批量加购')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["listen-variable"])
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(STable, {
      ref: (_value, _refs) => {
        _refs['STableRef'] = _value
        STableRef.value = _value
      },
      "page-data": pageData.value,
      "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => ((pageData).value = $event)),
      api: _unref(getCombinationList),
      filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
      columns: _unref(columns).filter((v) => _unref(isMultiStore)() || !v.isMultiStore),
      tableConfig: _unref(tableConfig),
      isImmediatelyExec: false,
      onSelectionChange: handleSelection
    }, {
      expand: _withCtx(({ scope }) => [
        _createVNode(STable, {
          "table-data": scope.row.combinationProductItemList,
          columns: _unref(childColumns),
          showPagination: false
        }, {
          productSkuImg: _withCtx(({ row }) => [
            (row.productSkuImg)
              ? (_openBlock(), _createBlock(ShoppingPreview, {
                  key: 0,
                  image: row.productSkuImg.split(',')[0]
                }, null, 8, ["image"]))
              : _createCommentVNode("", true)
          ]),
          productTitle: _withCtx(({ row }) => [
            (row?.productDetailUrl)
              ? (_openBlock(), _createBlock(AppLink, {
                  key: 0,
                  to: row.platformType === 'YS' ? `/goods/${row.productCode}` : row?.productDetailUrl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row?.productTitle), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(row?.productTitle), 1))
          ]),
          productPropertiesName: _withCtx(({ row }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
              return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
            }), 128))
          ]),
          Subtotal: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(showCurrentUnit)(scope.row.goodsCountry === _unref(COUNTRY).KR, getSubtotal(row.unitNums * row.productSellPrice))), 1)
          ]),
          remainCombinationProductItemRespList: _withCtx(({ row }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.remainCombinationProductItemRespList || [], (v) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex-bwn",
                key: v.systemOrderNo
              }, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(v.remainCombinationQuantity), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('件')) + " (" + _toDisplayString(_unref(getJapanTime)(v.remainCombinationCloseTime)) + ") ", 1)
                ]),
                (v.canOver)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 0,
                      "popper-class": "pay-pop",
                      title: _unref(t)('点击完结 单品可以转普通商品库存'),
                      onConfirm: ($event: any) => (finished(v))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "text",
                          style: {"margin-right":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('完结')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["title", "onConfirm"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          addition: _withCtx(({ row }) => [
            (row.additionList?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    effect: "light"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, _toDisplayString(_unref(montageAddition)(row.additionList) || '-'), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(montageAddition)(row.additionList) || '-'), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "-"))
          ]),
          productSellPrice: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(showCurrentUnit)(scope.row.goodsCountry === _unref(COUNTRY).KR, row.productSellPrice)), 1)
          ]),
          _: 2
        }, 1032, ["table-data", "columns"])
      ]),
      combinationProductAdditionList: _withCtx(({ row }) => [
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", null, _toDisplayString((row.combinationProductAdditionList || []).map((v) => v.additionNameJp).join(',')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", {
                class: "line--3",
                style: {"text-decoration":"underline"},
                onClick: ($event: any) => (openAdtOrder(row))
              }, _toDisplayString((row.combinationProductAdditionList || []).map((v) => v.additionNameJp).join(',')), 9, _hoisted_11)
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_el_button, {
          type: "text",
          onClick: ($event: any) => (openAdtOrder(row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      createTime: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
      ]),
      combinationProductMainImg: _withCtx(({ row }) => [
        (row.combinationProductMainImg)
          ? (_openBlock(), _createBlock(ShoppingPreview, {
              key: 0,
              image: row.combinationProductMainImg
            }, null, 8, ["image"]))
          : _createCommentVNode("", true)
      ]),
      handler: _withCtx(({ scope }) => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(memberEventBox, {
            icon: "member_coin",
            "listen-variable": scope.row
          }, {
            default: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('编辑'),
                onClick: ($event: any) => (exit(scope.row))
              }, null, 8, ["title", "onClick"])
            ]),
            _: 2
          }, 1032, ["listen-variable"]),
          _createVNode(memberEventBox, {
            icon: "member_coin",
            "listen-variable": scope.row
          }, {
            default: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('加购'),
                loading: scope.row.addLoading,
                onClick: ($event: any) => (addSingleCart(scope.row))
              }, null, 8, ["title", "loading", "onClick"])
            ]),
            _: 2
          }, 1032, ["listen-variable"])
        ])
      ]),
      customerProductMsku: _withCtx(({ row }) => [
        _createVNode(CustomerProductMsku, { row: row }, null, 8, ["row"])
      ]),
      goodsCountry: _withCtx(({ row }) => [
        _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.goodsCountry)), 1)
      ]),
      productSellPrice: _withCtx(({ row }) => [
        _createElementVNode("div", null, _toDisplayString(_unref(showCurrentUnit)(row.goodsCountry === _unref(COUNTRY).KR, row.productSellPrice)), 1)
      ]),
      _: 1
    }, 8, ["page-data", "api", "filterData", "columns", "tableConfig"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              isGroup: true,
              noSpot: true,
              list: proxy.value,
              "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((proxy).value = $event)),
              onCommit: handleAdt,
              countryCode: productCountyCode.value,
              type: "AdtOrder"
            }, null, 8, ["list", "countryCode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    _createVNode(BatchSearch)
  ]))
}
}

})